import React, { useState, useRef, useEffect } from 'react'
import { Modal } from 'antd'
import { useDebounceFn } from 'ahooks'
import FileTreeData from '../../common/fileTreeData'
import request from '../../utils/request'
import Icon from '../icon'
import { PLATFORM_CONFIG_ENUM } from '../platformConfig'
import { MODES, QUERY_TYPE_VALUE } from './enum'
import RightList from './rightList'
import LeftBlock from './leftBlock'
import RightHeader from './rightHeader'
import { getTagNameList } from './utils'
import MnAntdProvider from '../../common/antdPrefix'
import './commonInspiration.less'

export default ({
  batchSelected,
  visible,
  onClose,
  afterJoin,
  onAssociateTask,
  hasCurInstated,
  onUpdateInspiration,
  ...otherProps
}) => {
  const currentViewBlog = { ...otherProps.currentViewBlog, ...otherProps.currentViewBlog?.lastBlogList?.[0] }
  const getHasCurInstated = (_inspirationId) => (hasCurInstated ? _inspirationId : null)
  //
  const platformId = Number(currentViewBlog?.platformId) || Number(currentViewBlog?.mnPlatformType)
  const currentDto = currentViewBlog?.[PLATFORM_CONFIG_ENUM.get(platformId)?.dto]

  const blogList = batchSelected?.length
    ? batchSelected
    : [
      {
        blogId: currentViewBlog.imageGroupEntityId,
        platformId,
        sitePlatformId: currentViewBlog.sitePlatformId,
        inspirationId: getHasCurInstated(currentViewBlog.inspirationId),
        colorId: currentViewBlog?.colorId,
        skc: currentViewBlog?.skc,
      },
    ]

  const treeData = useRef()
  const [loading, setLoading] = useState(false)
  const [inspirationGroups, setInspirationGroups] = useState([])

  const [formParams, setFromParams] = useState({
    styleTitle: currentViewBlog?.imageEntityExtend?.styleTitle || null,
    price: blogList.length > 1 ? null : currentViewBlog?.imageEntityExtend?.price, // 参考价格
    tags: new Set(), // tagNameList 标签列表
    description: null, // 描述
    gender: null, // 行业
    propertyValueParamList: [], // 自
  })
  const [selectIds, setSelectIds] = useState([])
  const [selectItems, setSelectItems] = useState([])
  const [singleCollection, setSingleCollection] = useState(true) // 单选采集
  //
  const [keyWords, setKeyWords] = useState()
  const pageParams = useRef({
    start: 0,
    pageSize: 20,
  })
  const resultList = useRef([])
  const totalRef = useRef(0)
  const [queryType, setQueryType] = useState(3)

  useEffect(() => {
    setLoading(true)
    fetchIdeaMassList(queryType)
    if (!batchSelected?.length) {
      fetchTags().then((imgTags) => {
        setFromParams((pre) => ({ ...pre, tags: new Set(imgTags.map((t) => t.tagName)) }))
      })
    }
  }, [])

  const fetchTags = async () => {
    if (currentViewBlog.imageGroupEntityId) {
      const res = await request.get('/zhikuan/img-tag/list-img-tag', { params: { entityId: currentViewBlog.imageGroupEntityId } })
      return res
    }
    return []
  }

  const fetchIdeaMassList = async (_queryType, _keyWords = keyWords, _pageParams = pageParams.current) => {
    setLoading(true)
    const obj = {
      queryType: _queryType,
      onlyExistInspiration: 0,
    }
    if (_queryType === QUERY_TYPE_VALUE.collected) {
      obj.queryType = 3
      obj.onlyExistInspiration = 1
    }
    // 兼容跨境platformId
    const res = await request.post('/zhikuan/ins/inspiration/list-collect-inspiration-tree', {
      ...obj,
      ..._pageParams,
      colorId: currentViewBlog?.colorId,
      likeName: _keyWords,
      blogId: blogList.length > 1 ? null : currentViewBlog.imageGroupEntityId,
      platformId,
    })
    totalRef.current = res.resultCount
    const tempResult = _pageParams.start === 0
      ? (resultList.current = res.resultList)
      : (resultList.current = [...resultList.current, ...res.resultList])
    treeData.current = new FileTreeData({
      data: tempResult,
      checkedValues: selectIds,
      childrenKey: 'childs',
      collectNum: blogList.length,
    })
    setInspirationGroups(treeData.current.data)
    setLoading(false)
  }

  const onChangeTab = (val) => {
    setQueryType(val)
    pageParams.current.start = 0
    fetchIdeaMassList(val)
  }

  const batchAddTag = async () => {
    const tagNameList = getTagNameList(formParams.tags)
    if (!tagNameList.length) {
      return
    }
    await request.post('/zhikuan/img-tag/batch-add', {
      blogList: batchSelected.map((m) => ({ entityId: m.blogId })),
      tagNameList,
    })
  }

  const onFormChange = (valObj) => {
    setFromParams((pre) => ({ ...pre, ...valObj }))
  }
  const [clearAction, setClearAction] = useState({}) // 奇淫技巧?

  const [saveImgUrlList, setSaveImgUrlList] = useState([])

  const { run } = useDebounceFn(
    (val) => {
      fetchIdeaMassList(queryType, val)
    },
    { wait: 100 }
  )

  return (
    <MnAntdProvider>
    <Modal
      visible={visible}
      bodyStyle={{ padding: 0, width: 884, borderRadius: '9px', overflow: 'hidden' }}
      width="auto"
      closable={false}
      footer={false}
      centered
      wrapClassName="mn-add-into-idea-mass-modal-wrapper"
    >
      <div className="mn-add-into-idea-mass-modal" onClick={(e) => e && e.stopPropagation()}>
        <LeftBlock
          hasCurInstated={hasCurInstated}
          formParams={formParams}
          onFormChange={onFormChange}
          mode={blogList.length > 1 ? MODES.PURCHASE : MODES.COLLECT}
          currentViewBlog={currentViewBlog}
          currentDto={currentDto}
          blogList={blogList}
          platformId={platformId}
          onImageChange={(val) => {
            setSaveImgUrlList(val)
          }}
        />
        <div className="common-idea-mass-wrapper">
          <div className="mn-add-into-idea-mass-modal-header-2">
            {blogList.length > 1 ? '批量采集至美念' : '采集至美念'}
            <div className="add-into-idea-mass-modal-close" onClick={() => onClose()}>
              <Icon type="m-guanbi" />
            </div>
          </div>
          <RightHeader
            selects={selectIds}
            onClear={async () => {
              selectIds.length = 0
              selectItems.length = 0
              await fetchIdeaMassList(queryType)
              setClearAction({})
            }}
            mode={singleCollection}
            onMode={async () => {
              selectIds.length = 0
              selectItems.length = 0
              setSingleCollection(!singleCollection)
              await fetchIdeaMassList(queryType)
              setClearAction({})
            }}
          />
          <RightList
            onLoad={() => {
              pageParams.current.start += 20
              if (pageParams.current.start < totalRef.current) {
                fetchIdeaMassList(queryType)
              }
            }}
            keyWords={keyWords}
            onKeyWords={(val) => {
              pageParams.current.start = 0
              setKeyWords(val)
              run(val)
            }}
            clearAction={clearAction}
            onAssociateTask={onAssociateTask}
            formParams={formParams}
            selectIds={selectIds}
            setSelectIds={setSelectIds}
            selectItems={selectItems}
            setSelectItems={setSelectItems}
            //
            blogList={blogList}
            data={inspirationGroups}
            afterJoin={afterJoin}
            onClose={onClose}
            queryType={queryType}
            treeData={treeData.current}
            onChangeTab={onChangeTab}
            //
            batchAddTag={batchAddTag}
            currentViewBlog={currentViewBlog}
            batchSelected={batchSelected}
            saveImgUrlList={saveImgUrlList}
            //
            singleCollection={singleCollection}
            onInit={() => {
              pageParams.current.start = 0
              fetchIdeaMassList(queryType)
            }}
            loading={loading}
            onUpdateInspiration={onUpdateInspiration}
          />
        </div>
      </div>
    </Modal>
    </MnAntdProvider>
  )
}
